import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { useNavigate } from 'react-router-dom';

/**
 * GoogleSignInButton — wraps @react-oauth/google's GoogleLogin and posts
 * the credential (id_token) to /api/auth/google. Reuses our existing
 * AuthProvider state.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT
 * URLS, THIS BREAKS THE AUTH
 */
const GoogleSignInButton = ({ onAfterSignIn, label = 'Continue with Google' }) => {
  const { setSession } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  const handleCredential = async (resp) => {
    if (!resp?.credential) {
      toast.error('Google sign-in failed');
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post('/auth/google', { credential: resp.credential });
      // mirror our existing login flow
      localStorage.setItem('bx_token', data.token);
      localStorage.setItem('bx_user', JSON.stringify(data.user));
      if (setSession) setSession(data.token, data.user);
      toast.success(`welcome${data.user?.username ? `, @${data.user.username}` : ''}`);
      if (onAfterSignIn) onAfterSignIn(data.user);
      else nav('/home');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'sign-in failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="w-full" data-testid="google-signin-wrap">
      <GoogleLogin
        onSuccess={handleCredential}
        onError={() => toast.error('Google sign-in cancelled')}
        theme="filled_black"
        text={label === 'Continue with Google' ? 'continue_with' : 'signin_with'}
        shape="pill"
        size="large"
        width="320"
      />
      {busy && <div className="text-[10px] uppercase tracking-widest text-white/60 mt-2 text-center">signing in…</div>}
    </div>
  );
};

export default GoogleSignInButton;
